import { createAction, props } from '@ngrx/store';
import { ErrorDetail, UserDomain, UserDomainRecord, UserDomainRecordCreate } from '../../synaps-media.types';

// Load domains
export const loadDomains = createAction(
  '[Domains] Load Domains'
);

export const loadDomainsSuccess = createAction(
  '[Domains] Load Domains Success',
  props<{ domains: UserDomain[] }>()
);

export const loadDomainsFailure = createAction(
  '[Domains] Load Domains Failure',
  props<{ error: ErrorDetail }>()
);

// Load single domain
export const loadDomain = createAction(
  '[Domains] Load Domain',
  props<{ domain: string }>()
);

export const loadDomainSuccess = createAction(
  '[Domains] Load Domain Success',
  props<{ domain: UserDomain }>()
);

export const loadDomainFailure = createAction(
  '[Domains] Load Domain Failure',
  props<{ error: ErrorDetail }>()
);

// Add domain record
export const addDomainRecord = createAction(
  '[Domains] Add Domain Record',
  props<{ domain: string, record: Partial<UserDomainRecordCreate> }>()
);

export const addDomainRecordSuccess = createAction(
  '[Domains] Add Domain Record Success',
  props<{ record: UserDomainRecord, domain: string }>()
);

export const addDomainRecordFailure = createAction(
  '[Domains] Add Domain Record Failure',
  props<{ error: ErrorDetail }>()
);

// Update domain record
export const updateDomainRecord = createAction(
  '[Domains] Update Domain Record',
  props<{ domain: string, recordId: number, record: Partial<UserDomainRecordCreate> }>()
);

export const updateDomainRecordSuccess = createAction(
  '[Domains] Update Domain Record Success',
  props<{ record: UserDomainRecord, domain: string }>()
);

export const updateDomainRecordFailure = createAction(
  '[Domains] Update Domain Record Failure',
  props<{ error: ErrorDetail }>()
);

// Delete domain record
export const deleteDomainRecord = createAction(
  '[Domains] Delete Domain Record',
  props<{ domain: string, recordId: number }>()
);

export const deleteDomainRecordSuccess = createAction(
  '[Domains] Delete Domain Record Success',
  props<{ domain: string, recordId: number }>()
);

export const deleteDomainRecordFailure = createAction(
  '[Domains] Delete Domain Record Failure',
  props<{ error: ErrorDetail }>()
);

// Select domain
export const selectDomain = createAction(
  '[Domains] Select Domain',
  props<{ domainId: number }>()
);
